//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
(function () {
    'use strict';
    angular.module('container.components')
        .directive('srsngCookieDialog', cookieDialog);

    function cookieDialog() {

        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/components/cookie-dialog/cookie-dialog.html',
            scope: {
             },
            controller: controller,
            link: link
        };

        function controller($scope, $element, $rootScope, Event, userSettingsService) {

            $scope.confirm = confirm;
            $scope.resetDialog = resetDialog;
            $scope.removeUserSetting = removeUserSetting;

            $rootScope.$on(Event.USER_LOGGED_IN, resetDialog);

            function confirm() {
                userSettingsService.saveUserSetting('container', 'cookiesAccepted', true);
                hideDialog();
            }

            //This is just for test purposes
            function removeUserSetting() {
                userSettingsService.removeUserSetting('container', 'cookiesAccepted');
            }

            function showDialogIfCookiesNotAccepted() {
                userSettingsService.loadUserSetting('container', 'cookiesAccepted')
                    .then(cookiesAccepted => {
                        if (cookiesAccepted !== true) {
                            showDialog();
                        }
                    }, () => {
                        showDialog();
                    });
            }

            function showDialog() {
                var dialogHeight = $element.prop('scrollHeight');
                
                $element.css("height", dialogHeight + 'px');
                $element.addClass('visible');

                $element.one('transitionend', (e) => {
                    $element.css("height", null);
                })
                
              }

            function hideDialog() {
                var dialogHeight = $element.prop('scrollHeight');
                                

                $element.css("height", dialogHeight + 'px');
                    
                requestAnimationFrame(function() {
                    $element.css("height", 0 + 'px');
                    $element.removeClass('visible');
                });
            }

            function resetDialog() {
                $element.removeClass('transitionEnabled');
                hideDialog();
                setTimeout(function () {
                    $element.addClass('transitionEnabled');
                    showDialogIfCookiesNotAccepted();
                }, 1500)
            }
        }

        function link($scope, $element, attrs) {
            $scope.resetDialog();
        }
    }

})();

